import React from 'react';
import { connect } from 'react-redux';
import {msg} from "constants/message";
import {ShowIf} from 'components/utils';
import {validatable} from 'components/utils';

class AutoSuggest extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value,
      searching: false,
      openSuggest: false,
      result: [],
      page: {
        totalElements: 0
      },
      isValid: true
    }
  }

  validate() {
    if (!this.state.value.trim()) {
      this.setState({
        isValid: false
      });
      this.textInput.focus();
      return false;
    } else {
      this.setState({
        isValid: true
      });
      return true;
    }
  }

  handleBlur() {
    setTimeout(() => {
      this.setState({
        openSuggest: false
      });
    }, 500);
  }

  handleTyping(e) {
    let value = e.target.value;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (!value) {
      this.state.openSuggest = false;
    } else {
      this.setState({
        value
      });

      this.typingTimeout = setTimeout(() => {
        this.setState({searching: true});
        this.props.onSearch(value).then(response => {
          if (response != null) {
            this.setState({
              result: response.result,
              page: response.page,
              openSuggest: true,
              searching: false
            });
          } else {
            this.setState({
              result: [],
              searching: false,
              page: { totalElements: 0 }
            });
          }
        }).catch(err => {});
      }, 1000);
    }
    this.props.onChange(value);
  }

  itemSelected(item) {
    this.props.onSelected(item);
    this.state.openSuggest = false;
    this.setState({...this.state});
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value != nextProps.value) {
      this.setState({
        value: nextProps.value
      });
    }
  }

  render() {
    return (
      <div className={`autocomplete-box ${this.props.className}`}>
        <label className="pt-label wrap-autocomplete">

          <span className="val-title">{this.props.label}
            <ShowIf condition={this.props.isRequired}>
              <span className="text-required pt-text-muted"> *</span>
            </ShowIf>
          </span>


          <input ref={(input) => { this.textInput = input; }}
            className={`pt-input ${this.state.searching ? 'tt-loading' : ''} ${!this.state.isValid && !this.state.value.trim() ? 'pt-intent-danger' : ''}`}
            maxLength={this.props.maxLength}
            name={this.props.name}
            placeholder={this.props.placeholder}
            value={this.state.value} onBlur={this.handleBlur.bind(this)}
            onChange={this.handleTyping.bind(this)} type="text" autoComplete = "off"
          />

          <ShowIf condition={!this.state.isValid && !this.state.value.trim()}>
            <div className="pt-form-helper-text">{msg.messageDefault}</div>
          </ShowIf>
        </label>
        <div className="autocomplete-container" style={{top:'0px'}}>
          <ShowIf condition={this.state.openSuggest}>
            <ul>
              {
                this.state.result.map((item, i) => {
                  return (
                    <li key={i} className="item-person" onClick={this.itemSelected.bind(this, item)}>
                      <div className="list-items">
                        <p className="mb10 item-text">{item.ten}</p>
                      </div>
                    </li>
                  )
                })
              }
            </ul>
          </ShowIf>
        </div>
      </div>
    )
  }
}

AutoSuggest.defaultProps = {
  name: 'coQuanKhac',
  className: '',
  label: '',
  isRequired: false,
  placeholder: ''
}

export default connect()(validatable(AutoSuggest));



// WEBPACK FOOTER //
// ./src/components/modules/auto-complete/AutoSuggest.jsx